export default __webpack_public_path__ + "54de149f13a02242b52fbd3d0ca33215.svg";